import { useTranslation } from 'react-i18next';

const FooterNav = ({ step, setStep, history, handleCreate, submitting, S }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '16px 32px',
        borderTop: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.8)',
        display: 'flex',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <button
        onClick={() => (step > 1 ? setStep(step - 1) : history.push('/claims'))}
        style={{
          padding: '10px 20px',
          background: '#fff',
          border: `1px solid ${S.borderLight}`,
          borderRadius: 10,
          fontSize: 13,
          fontWeight: 600,
          color: S.textSecondary,
          cursor: 'pointer',
        }}
      >
        {step > 1 ? t('screens.claimsScreen.new.previous') : t('screens.claimsScreen.new.cancel')}
      </button>
      <div style={{ display: 'flex', gap: 8 }}>
        {step < 4 && (
          <button
            style={{
              padding: '10px 20px',
              background: '#fff',
              border: `1px solid ${S.borderLight}`,
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 500,
              color: S.textMuted,
              cursor: 'pointer',
            }}
          >
            {t('screens.claimsScreen.new.saveDraft')}
          </button>
        )}
        <button
          onClick={() => (step < 4 ? setStep(step + 1) : handleCreate())}
          disabled={submitting}
          style={{
            padding: '10px 24px',
            background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            cursor: submitting ? 'not-allowed' : 'pointer',
            opacity: submitting ? 0.7 : 1,
          }}
        >
          {submitting ? t('screens.claimsScreen.new.creating') : step < 4 ? t('screens.claimsScreen.new.continue') : t('screens.claimsScreen.new.createClaim')}
        </button>
      </div>
    </div>
  );
};

export default FooterNav;
